import Client from '../../lib/geodb-service-client'
import { pointsWithinBounds } from '../../lib/turfHelper'
import { getCustomerStats } from '../../lib/statsHelper'

export default {
  namespaced: 'true',
  state: {
    data: {
      type: 'FeatureCollection',
      features: []
    },
    dataReady: false,
    stats: {}
  },
  mutations: {
    setData (state, data) {
      state.data = data
    },
    setStats (state, stats) {
      state.stats = stats
    },
    setDataReady (state, status) {
      state.dataReady = status
    }
  },
  getters: {
    statsList: state => {
      return Object.keys(state.stats).map(id => ({ id, description: 'customerPanel.' + id, value: state.stats[id], valueType: id === 'totalSpent' ? 'cad' : 'number' }))
    }
  },
  actions: {
    async loadData ({ rootState, commit }) {
      commit('setDataReady', false)
      const client = new Client(rootState.auth.token, rootState.user.params.customersDataset)
      try {
        const data = await client.getGeoJSON()
        commit('setData', data)
        commit('setDataReady', true)
      } catch (error) {
        alert(this.$t('message.errorMessages.generic'))
      }
    },
    reloadStats ({ state, commit }, bounds) {
      const featureCollection = pointsWithinBounds(state.data, bounds)
      const stats = getCustomerStats(featureCollection)
      commit('setStats', stats)
    }
  }
}
